<!-- Spinner while term changes list is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the term changes. Click below try again.
    <button hc-button size="lg" (click)="loadTermChanges()">Reload Changes</button>
</div>

<div class="admin-term-changes-table-container" [hidden]="loadError || loading">
    <div class="admin-term-changes-control-bar">
        <button hc-button (click)="addRequest(addRequestModal)">Add Request</button>
        <hc-search-bar
            #searchbar
            placeholder="Search changes"
            (triggerSearch)="applyFilter($event)"
            class="admin-term-changes-search"
        ></hc-search-bar>
    </div>
    <table hc-table [borders]="false" [dataSource]="dataSource" hcSort>
        <!-- submitDate Column -->
        <ng-container hcColumnDef="submitDate">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="submitDateHeader">Submitted</th>
            <td hc-cell *hcCellDef="let element" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.submitDate | date: 'shortDate'}}</td>
        </ng-container>

        <!-- publishDate Column -->
        <ng-container hcColumnDef="publishDate">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="publishDateHeader">Published</th>
            <td hc-cell *hcCellDef="let element">
                <span *ngIf="element.publishDate && element.publishDate.toString() !== ignoreDate.toString() && element.publishDate.toString() !== deleteDate.toString()" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.publishDate | date: 'shortDate' }}</span>
                <span *ngIf="element.publishDate && element.publishDate.toString() === ignoreDate.toString()" (click)="requestClick(element)" class="admin-term-changes-cell"><em>Ignored</em></span>
                <span *ngIf="element.publishDate && element.publishDate.toString() === deleteDate.toString()" (click)="requestClick(element)" class="admin-term-changes-cell"><em>Term Removed</em></span>
            </td>
        </ng-container>
        
        <!-- TermID Column -->
        <ng-container hcColumnDef="termId">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="termIdHeader">Request</th>
            <td hc-cell *hcCellDef="let element" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.termId ? 'Edit' : 'Add' }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Term</th>
            <td hc-cell *hcCellDef="let element" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.name }}</td>
        </ng-container>

        <!-- Usage Column -->
        <ng-container hcColumnDef="usage">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="usageHeader">Definition or Guideline</th>
            <td hc-cell *hcCellDef="let element" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.usage }}</td>
        </ng-container>

        <!-- contributorName Column -->
        <ng-container hcColumnDef="contributorName">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="contributorNameHeader">Name</th>
            <td hc-cell *hcCellDef="let element" (click)="requestClick(element)" class="admin-term-changes-cell">{{ element.contributorName }}</td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="displayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No terms meet your search criteria.</span>
    </div>

    <hc-pagination
        [length]="listLength"
        [pageSize]="pageSize"
        [hidden]="loadError || loading"
    ></hc-pagination>
</div>

<ng-template #addRequestModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>Add Change Request</hc-modal-header>
        <hc-modal-body>
            <em class="admin-term-changes-modal-instructions">Use this form to add a request for an addition to the terminology list. To request an edit, use the "Request Change" action for that item on the Terminology List.</em>
            <form [formGroup]="addChangeControl">
                <hc-form-field>
                    <hc-label>Term to Add:</hc-label>
                    <input hcInput formControlName="name" placeholder="What term would you like to add?" [required]="true" />
                    <hc-error>A term is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Definition/Usage Rule:</hc-label>
                    <input hcInput formControlName="usage" placeholder="What is the definition/usage rule for this term?" [required]="true" />
                    <hc-error>Usage is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Comments (optional):</hc-label>
                    <textarea hcInput rows="4" cols="50" formControlName="comments" placeholder="Why are you suggesting this change?" ></textarea>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Contributor Name:</hc-label>
                    <input hcInput formControlName="contributorName" placeholder="What is your name?" [required]="true" />
                    <hc-error>Contributor name is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Contributor Email:</hc-label>
                    <input hcInput formControlName="contributorEmail" placeholder="At what email can we reach you?" [required]="true" />
                    <hc-error>Contributor is required</hc-error>
                </hc-form-field>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button
                hc-button
                [disabled]="data.edit ? !addChangeControl.dirty : !addChangeControl.valid"
                (click)="dismiss(); submitRequest();"
            >
                Add
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>

<ng-template #reviewChangeModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>Review Change Request - {{data.termId ? 'Change' : 'Add'}} Term</hc-modal-header>
        <hc-modal-body>
            <div *ngIf="changeModalLoading" class="pd-loader">
                <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
            </div>
            <div class="admin-term-changes-modal-container" [class.admin-term-changes-modal-loading]="changeModalLoading">
                <div class="admin-term-changes-add-details">
                    <em>
                        Below are the details of the submitted request.
                        If you would like to publish this request, use the form to the right to {{data.termId ? 'change the' : 'add an'}} entry to the terminology list.
                    </em>
                    <div class="admin-term-changes-modal-label">Term to {{data.termId ? 'Change' : 'Add'}}:</div>
                    <div class="admin-term-changes-modal-text">{{data.name}}</div>

                    <div class="admin-term-changes-modal-label">Definition/Usage Rule:</div>
                    <div class="admin-term-changes-modal-text">{{data.usage}}</div>

                    <div class="admin-term-changes-modal-label">Comments:</div>
                    <div class="admin-term-changes-modal-text">{{data.comment}}</div>

                    <div class="admin-term-changes-modal-label">Contributor:</div>
                    <div class="admin-term-changes-modal-text"><a [href]="'mailto:'+data.contributorEmail">{{data.contributorName}}</a></div>

                    <div class="admin-term-changes-modal-label">Submit Date:</div>
                    <div class="admin-term-changes-modal-text">{{data.submitDate | date: 'shortDate'}}</div>

                    <div class="admin-term-changes-modal-label">Publish Date:</div>
                    <div class="admin-term-changes-modal-text">
                        <span *ngIf="data.publishDate && data.publishDate.toString() !== ignoreDate.toString() && data.publishDate.toString() !== deleteDate.toString()">{{data.publishDate | date: 'shortDate'}}</span>
                        <span *ngIf="data.publishDate && data.publishDate.toString() === ignoreDate.toString()"><em>Ignored</em></span>
                        <span *ngIf="data.publishDate && data.publishDate.toString() === deleteDate.toString()"><em>Term Removed</em></span>
                        <span *ngIf="!data.publishDate"><em>Not Published</em></span>
                    </div>
                </div>
                <div class="admin-term-changes-add-form-container">
                    <form [formGroup]="adminTermControl" class="admin-term-changes-add-form">
                        <hc-form-field>
                            <hc-label>Term:</hc-label>
                            <input hcInput formControlName="name" placeholder="Enter term" class="term-input" [required]="true" (input)="termExists = false"/>
                            <hc-error>{{termExists ? 'Term already exists in the list' : 'A term is required'}}</hc-error>
                        </hc-form-field>
                        <hc-form-field>
                            <hc-label>Date Added:</hc-label>
                            <input hcInput [hcDatepicker]="picker1" formControlName="dateAdded" placeholder="Enter date..." [required]="true" />
                            <hc-datepicker-toggle hcSuffix [for]="picker1"></hc-datepicker-toggle>
                            <hc-datepicker #picker1></hc-datepicker>
                            <hc-error>A valid date is required</hc-error>
                        </hc-form-field>
                        <hc-form-field>
                            <hc-label>Types:</hc-label>
                            <hc-multiselect class="admin-terminology-select" required>
                                <ng-select
                                    [items]="types"
                                    [addTag]="false"
                                    [multiple]="true"
                                    dropdownPosition="bottom"
                                    placeholder="Search for types..."
                                    formControlName="types"
                                ></ng-select>
                            </hc-multiselect>
                            <hc-error>A type is required</hc-error>
                        </hc-form-field>
                        <hc-form-field>
                            <hc-label>Categories:</hc-label>
                            <hc-multiselect class="admin-terminology-select" required>
                                <ng-select
                                    [items]="categories"
                                    [addTag]="false"
                                    [multiple]="true"
                                    dropdownPosition="bottom"
                                    placeholder="Search for categories..."
                                    formControlName="categories"
                                ></ng-select>
                            </hc-multiselect>
                            <hc-error>A cateogry is required</hc-error>
                        </hc-form-field>
                        <hc-form-field>
                            <hc-label>Definition or Guideline:</hc-label>
                            <textarea
                                hcInput
                                rows="4"
                                cols="50"
                                formControlName="usage"
                                placeholder="Enter definition"
                                [required]="true"
                            ></textarea>
                            <hc-error>Definition is required</hc-error>
                        </hc-form-field>
                        <hc-form-field>
                            <hc-label>Example:</hc-label>
                            <textarea
                                hcInput
                                rows="4"
                                cols="50"
                                formControlName="example"
                                placeholder="Enter example"
                            ></textarea>
                        </hc-form-field>
                    </form>
                </div>  
            </div>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button hc-button buttonStyle="destructive" *ngIf="!adminTermControl.controls['id'].value" [disabled]="changeModalLoading" (click)="ignoreChange(data);">Ignore</button>
            <hc-split-button *ngIf="adminTermControl.controls['id'].value" hc-button buttonStyle="destructive" [disabled]="changeModalLoading" (click)="ignoreChange(data)">
                Ignore
                <button hcMenuItem (click)="deleteTerm(data)">
                    <hc-icon hcMenuIcon fontSet="fa" fontIcon=" fa-trash"></hc-icon>
                    <span hcMenuText>Delete Term</span>
                </button>
            </hc-split-button>
            <button hc-button [disabled]="changeModalLoading || !adminTermControl.dirty || !adminTermControl.valid" (click)="publishChange(data)">Publish</button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>